export default "__VITE_ASSET__gLovfBeO__"